// Streams the /api/ai/research SSE endpoint and dispatches parsed events.
export async function streamResearch({ provider, messages, model, signal, onDelta, onSources, onDone, onError }) {
  const API = process.env.REACT_APP_BACKEND_URL;
  let res;
  try {
    res = await fetch(`${API}/api/ai/research`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "include",
      body: JSON.stringify({ provider, messages, model }),
      signal,
    });
  } catch (e) {
    onError?.("Network error reaching the server");
    return;
  }
  if (!res.ok || !res.body) {
    let detail = "Request failed";
    try { detail = (await res.json()).detail || detail; } catch { /* ignore */ }
    onError?.(detail);
    return;
  }
  const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
  let buf = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += value;
    const frames = buf.split("\n\n");
    buf = frames.pop();
    for (const frame of frames) {
      const evLine = frame.split("\n").find((l) => l.startsWith("event:"));
      const dataLine = frame.split("\n").find((l) => l.startsWith("data:"));
      if (!dataLine) continue;
      const event = evLine ? evLine.slice(6).trim() : "message";
      let data = {};
      try { data = JSON.parse(dataLine.slice(5).trim()); } catch { /* ignore */ }
      if (event === "delta") onDelta?.(data.text || "");
      else if (event === "sources") onSources?.(data.sources || []);
      else if (event === "error") onError?.(data.message || "AI error");
      else if (event === "done") onDone?.();
    }
  }
  onDone?.();
}
